export default "__VITE_ASSET__DtbSFh6h__"